var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"row row-cols-1 mt-5"},[_c('main',{staticClass:"mt-3 w-75 m-auto"})])])])
}]

export { render, staticRenderFns }